import { Avatar } from "@maxhub/max-ui"

export const AvatarTextExample = {
    title: 'Avatar.Text',
    defaultPlatform: 'ios',
    defaultZoom: 100,

    controls: [
        {
            name: 'children',
            label: 'children',
            type: 'text',
            tsType: 'string',
            default: 'VT',
        },
        {
            name: 'gradient',
            label: 'gradient',
            type: 'enum',
            tsType: ['"custom"', '"red"', '"orange"', '"green"', '"blue"', '"purple"'],
            default: 'red',
            options: ['custom', 'red', 'orange', 'green', 'blue', 'purple'],
        },
    ],

    Preview({ props }){
        return (
            <Avatar.Container>
                <Avatar.Text gradient={props.gradient}>
                    {props.children}
                </Avatar.Text>
            </Avatar.Container>
        )
    },

    getCode(props){
        return `<Avatar.Container>
  <Avatar.Text gradient="${props.gradient}">
    ${props.children}
  </Avatar.Text>
</Avatar.Container>`
    }

}